import React from "react";

import "./style";
import Suits from "./Suits";

function Maincontent() {
  return (

    <Suits />



  );
}

export default Maincontent;
